export default {
  domain: process.env.VUE_APP_COGNITO_DOMAIN,
  scope: ['email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
  redirectSignIn: process.env.VUE_APP_REDIRECT_URL,
  redirectSignOut: process.env.VUE_APP_REDIRECT_URL,
  responseType: 'token',
};
